import React from 'react';
import { useSelector } from 'react-redux';
import { AppBanner, Button } from '@pwc/pwc-deals-ui';
import { Constants } from '@pwc/pwc-deals-web-common';
import { getAppBannerConfig } from './structuredAnalysisBannerSelectors';
import { getProjectTerritory } from '../../../project/projectSlice';

const AU_BANNER_TEXT = `You may choose to use Junction to manipulate output prepared by PwC for its 
client (“your results”).  Your results are for your convenience and general information purposes only.  
PwC makes no representation or warranty with respect to your results, including, without limitation, fitness for any particular purpose. 
PwC is not liable for your or others’ use of, or reliance on, your results. 
Information should be viewed in conjunction with the
following`;

const BANNER_TEXT = `You are outside of the PwC default view. Your data selections may not be
consistent with the commentary and/or observations presented on this
screen. Information should be viewed in conjunction with the
following`;

const getLanguageByTerritory = (territory) => {
  if (territory === Constants.TERRITORY_CODES.AUSTRALIA) {
    return AU_BANNER_TEXT;
  }
  return BANNER_TEXT;
};

const StructuredAnalysisViewingToggledDataBanner = ({
  showDisclaimerModal,
}) => {
  const config = useSelector(getAppBannerConfig);
  const territory = useSelector(getProjectTerritory);

  const text = getLanguageByTerritory(territory);

  return (
    <AppBanner
      showBanner={config.showBanner}
      dataTestId="viewing-toggled-data-banner"
    >
      <div data-testid="disclaimer-warning-text">
        {text}
        &nbsp;
        <Button
          className="button-link"
          key="project-disclaimer"
          data-testid="project-disclaimer-link"
          onClick={() => showDisclaimerModal(true)}
        >
          disclaimer.
        </Button>
      </div>
    </AppBanner>
  );
};

export default StructuredAnalysisViewingToggledDataBanner;
